import { jsx as i } from "react/jsx-runtime";
import c from "react-select/async";
import "react-select";
import { buildCustomDropdownComponents as a } from "../Dropdown/CustomComponents.js";
import d from "../Dropdown/hooks/useGetDropdownStyles.js";
function D(o) {
  const {
    dataNoTranslate: t,
    styles: u,
    size: s = "small",
    error: r = !1,
    menuWidth: e,
    children: n,
    ...m
  } = o, p = d({
    size: s,
    error: r,
    menuWidth: e
  }), l = a({
    dataNoTranslate: t,
    children: n
  });
  return /* @__PURE__ */ i(
    c,
    {
      components: l,
      styles: p,
      ...m
    }
  );
}
export {
  D as default
};
